export class CacheManager {
    constructor() {
        this.stores = new Map();
    }
    registerStore(name, store, tag) {
        if (this.stores.has(name)) {
            throw new Error(`Cache store with name "${name}" is already registered.`);
        }
        this.stores.set(name, { store, tag });
    }
    getStore(name) {
        const entry = this.stores.get(name);
        if (!entry) {
            throw new Error(`Cache store with name "${name}" is not registered.`);
        }
        return entry.store;
    }
    tag(tag) {
        for (const entry of this.stores.values()) {
            if (entry.tag === tag) {
                return entry.store;
            }
        }
        throw new Error(`No cache store with tag "${tag}" is registered.`);
    }
    tagAll(tag) {
        const result = [];
        for (const entry of this.stores.values()) {
            if (entry.tag === tag) {
                result.push(entry.store);
            }
        }
        return result;
    }
}
//# sourceMappingURL=CacheManager.js.map